export const NUMBER_BOOLEAN_CHOICES = [
  { id: '1', label: 'Да' },
  { id: '0', label: 'Нет' },
];
